import "antd/lib/icon/style";
import _Icon from "antd/lib/icon";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input"; /*@通用-通用函数*/
import CryptoJs from 'crypto-js';
import * as qs from 'qs';
import React from "react";
import SR100 from "../assets/img/devicePic/SR100 Copy.png";
import SR100W2L0 from "../assets/img/devicePic/SR100-W2L0 Copy.png";
import SR100W2L1 from "../assets/img/devicePic/SR100-W2L1 Copy.png";
import SR101W2L1P10M3 from "../assets/img/devicePic/SR101-W2L1-P10M3 Copy.png";
import SR105P5 from "../assets/img/devicePic/SR105-P5 Copy.png";
import SR105W1P5 from "../assets/img/devicePic/SR105-W1-P5 Copy.png";
import SR105W1L1P5 from "../assets/img/devicePic/SR105-W1L1-P5 Copy.png";
import SR105W1L1P10S from "../assets/img/devicePic/SR105-W1L1-P10S Copy.png"; // import SR500P8SD from "../assets/img/devicePic/SR500-P8SD.png";
import SR502P8SD from "../assets/img/devicePic/SR502-P8SD Copy.png";
import SR300 from "../assets/img/devicePic/SR300 Copy.png";
import SR302P6C from "../assets/img/devicePic/SR302-P6C Copy.png";
import SR302W1P6C from "../assets/img/devicePic/SR302-W1-P6C Copy.png";
import SR302W1L1P6C from "../assets/img/devicePic/SR302-W1L1-P6C Copy.png";
import SR303W1L1P6C from "../assets/img/devicePic/SR303-W1L1-P6C Copy.png";
import nodevice from "../assets/img/devicePic/nodevice Copy.png";
import VM from "../assets/img/devicePic/VM Copy.png";
import DOCKER from "../assets/img/devicePic/DOCKER Copy.png";
import SR105P5F from "../assets/img/devicePic/SR105-P5F Copy.png";
import SR920 from "../assets/img/devicePic/SR920.png";
var validateIp = function validateIp(rule, value, callback) {
  value = value ? value.replace(/\n|\r\n|,\n|,\r\n/g, ",") : value;
  var arr = value ? value.split(",") : [],
    regExp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
  var flag4 = value === 'any';
  if (value && value.indexOf('-') !== -1) {
    return callback("Input in the format of 1.1.1.0/24,1.1.1.1");
  }
  for (var i = 0, len1 = arr.length; i < len1; i++) {
    var flag1 = false,
      flag2 = false,
      flag3 = false;
    var ipStr = arr[i],
      ipStr1 = ipStr.indexOf("/") !== -1; // , ipStr2 = (ipStr.indexOf("-") !== -1);
    if (regExp.test(ipStr)) {
      flag1 = !flag1;
    }
    if (ipStr1) {
      var ipSeg = ipStr.split("/"),
        regNum = /^[0-9]$|^[1,2]\d$|^3[0-2]$/;
      if (regExp.test(ipSeg[0]) && regNum.test(ipSeg[1])) {
        flag2 = !flag2;
      }
    } // if (ipStr2) {
    //     var ipRange = ipStr.split("-"),
    //         ip1 = ipRange[0],
    //         ip2 = ipRange[1],
    //         temp1 = ip1.split("."),
    //         temp2 = ip2.split("."),
    //         temp3 = false;
    //     for (var j = 0; j < 4; j++) {
    //         var num1 = +temp1[j], num2 = +temp2[j];
    //         if (num1 < num2) {
    //             temp3 = true;
    //             break;
    //         } else if (num1 > num2) {
    //             temp3 = false;
    //             break;
    //         }
    //     }
    //     if (regExp.test(ip1) && regExp.test(ip2) && temp3) {
    //         flag3 = !flag3;
    //     }
    // }
    if (!flag1 && !flag2 && !flag3 && !flag4) {
      return callback("Input in the format of 1.1.1.0/24,1.1.1.1");
    }
  }
  return callback();
};
var validateIpAll = function validateIpAll(rule, value, callback, maxlength, shouldnotany) {
  var arr = value ? value.split(",") : [],
    regExp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
  var flag4 = value === 'any';
  if (maxlength && arr.length > maxlength) {
    return callback("Up to input" + maxlength + "Group IP");
  }
  for (var i = 0, len1 = arr.length; i < len1; i++) {
    var flag1 = false,
      flag2 = false,
      flag3 = false;
    var ipStr = arr[i],
      ipStr1 = ipStr.indexOf("/") !== -1,
      ipStr2 = ipStr.indexOf("-") !== -1;
    if (regExp.test(ipStr)) {
      flag1 = !flag1;
    }
    if (ipStr1) {
      var ipSeg = ipStr.split("/"),
        regNum = /^[0-9]$|^[1,2]\d$|^3[0-2]$/;
      if (regExp.test(ipSeg[0]) && regNum.test(ipSeg[1])) {
        flag2 = !flag2;
      }
    }
    if (ipStr2) {
      var ipRange = ipStr.split("-"),
        ip1 = ipRange[0],
        ip2 = ipRange[1],
        temp1 = ip1.split("."),
        temp2 = ip2.split("."),
        temp3 = false;
      for (var j = 0; j < 4; j++) {
        var num1 = +temp1[j],
          num2 = +temp2[j];
        if (num1 < num2) {
          temp3 = true;
          break;
        } else if (num1 > num2) {
          temp3 = false;
          break;
        }
      }
      if (regExp.test(ip1) && regExp.test(ip2) && temp3) {
        flag3 = !flag3;
      }
    }
    if (String(shouldnotany) === 'true') {
      if (!flag1 && !flag2 && !flag3) {
        return callback("Input in the format 1.1.1.1-1.1.1.10, 1.1.1.0/24, 1.1.1.1");
      }
    } else {
      if (!flag1 && !flag2 && !flag3 && !flag4) {
        return callback("Input in the format 1.1.1.1-1.1.1.10, 1.1.1.0/24, 1.1.1.1");
      }
    }
  }
  return callback();
};
var validateOnlyIpd = function validateOnlyIpd(rule, value, callback, onlyOne, shouldnotany, msg) {
  value = value ? value.replace(/\n|\r\n|,\n|,\r\n/g, ",") : value;
  var arr = value ? value.split(",") : [],
    regExp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
  var flag4 = value === 'any';
  if (value && String(onlyOne) === 'true' && value.indexOf(',') !== -1) {
    return callback(msg ? msg : "Input in 1.1.1.0/24 format");
  }
  if (value && value.indexOf('-') !== -1) {
    return callback(msg ? msg : "Input in 1.1.1.0/24 format");
  }
  for (var i = 0, len1 = arr.length; i < len1; i++) {
    var flag1 = false;
    var ipStr = arr[i],
      ipStr1 = ipStr.indexOf("/") !== -1; // , ipStr2 = (ipStr.indexOf("-") !== -1);
    if (ipStr1) {
      var ipSeg = ipStr.split("/"),
        regNum = /^[0-9]$|^[1,2]\d$|^3[0-2]$/;
      if (regExp.test(ipSeg[0]) && regNum.test(ipSeg[1])) {
        flag1 = !flag1;
      }
    }
    if (String(shouldnotany) === 'true') {
      if (!flag1) {
        return callback(msg ? msg : "Input in 1.1.1.0/24 format");
      }
    } else {
      if (!flag1 && !flag4) {
        return callback(msg ? msg : "Input in any, 1.1.1.0/24 format");
      }
    }
  }
  return callback();
};
var validateOnlyIp = function validateOnlyIp(rule, value, callback, maxLength) {
  var arr = value ? value.split(",") : [],
    regExp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
  if (value && value.indexOf('-') !== -1 || value && value.indexOf('/') !== -1) {
    return callback("Input in the format of 1.1.1.1");
  }
  if (maxLength && arr.length > maxLength) {
    return callback("Up to input" + maxLength + "Group IP");
  }
  for (var i = 0, len1 = arr.length; i < len1; i++) {
    var flag1 = false;
    var ipStr = arr[i];
    if (regExp.test(ipStr)) {
      flag1 = !flag1;
    }
    if (!flag1) {
      return callback("Input in the format of 1.1.1.1");
    }
  }
  return callback();
}; /**
   * 端口字段校验函数
   **/
var validatePort = function validatePort(rule, value, callback, maxlength, min) {
  var temp,
    arr = value ? value.toString().split(",") : [],
    regExp = /0|(^[1-9]\d{0,3}$)|(^[1-5]\d{4}$)|(^6[0-4]\d{3}$)|(^65[0-4]\d{2}$)|(^655[0-2]\d$)|(^6553[0-5]$)/;
  var flag4 = value === 'any';
  var flag5 = value === 'ALL';
  if (min) {
    regExp = /(^[1-9]\d{0,3}$)|(^[1-5]\d{4}$)|(^6[0-4]\d{3}$)|(^65[0-4]\d{2}$)|(^655[0-2]\d$)|(^6553[0-5]$)/;
  }
  if (maxlength && maxlength === 1 && value && value.indexOf('-') > -1) {
    return callback("Up to input" + maxlength + "A port number");
  }
  if (maxlength && arr.length > maxlength) {
    if (maxlength === 1) {
      return callback("Up to input" + maxlength + "A port number");
    } else {
      return callback("Up to input" + maxlength + "Group Port Number");
    }
  }
  for (var i = 0, len = arr.length; i < len; i++) {
    var portI = arr[i],
      portTrue = portI.indexOf("-") !== -1;
    temp = false;
    if (portTrue) {
      var port1 = portI.split("-"),
        port11 = +port1[0],
        port12 = +port1[1];
      if (regExp.test(port11) && regExp.test(port12) && port11 < port12) {
        temp = !temp;
      }
    } else {
      if (regExp.test(portI)) {
        temp = !temp;
      }
    }
    if (!temp && !flag4 && !flag5) {
      if (min) {
        return callback("Port range 1-65535");
      } else {
        return callback("Port range 0-65535");
      }
    }
  }
  return callback();
}; /**
   * 数字千分逗号处理函数
   **/
function addComma(val) {
  //根据`.`作为分隔，将val值转换成一个数组
  var aIntNum = val.toString().split('.'); // 整数部分
  var iIntPart = aIntNum[0]; // 小数部分（传的值有小数情况之下）
  var iFlootPart = aIntNum.length > 1 ? '.' + aIntNum[1] : '';
  var rgx = /(\d+)(\d{3})/; // 如果整数部分位数大于或等于5
  if (iIntPart.length >= 5) {
    // 根据正则要求，将整数部分用逗号每三位分隔
    while (rgx.test(iIntPart)) {
      iIntPart = iIntPart.replace(rgx, '$1,$2');
    }
  }
  return iIntPart + iFlootPart;
} /**
  * 在有源IP,目标IP批量输入的页面中,对后台返回数据处理函数
  **/
var initBackDataProcess = function initBackDataProcess(backData) {
  if (backData.result.length > 0) {
    for (var _key2 in backData.result) {
      if (backData.result[_key2].dst_ip_group.length > 0) {
        backData.result[_key2].dstIpType = "2";
      } else {
        backData.result[_key2].dstIpType = "1";
      }
      if (backData.result[_key2].src_ip_group.length > 0) {
        backData.result[_key2].srcIpType = "2";
      } else {
        backData.result[_key2].srcIpType = "1";
      }
      if (backData.result[_key2].dst_port_group.length > 0) {
        backData.result[_key2].dstPortType = "2";
      } else {
        backData.result[_key2].dstPortType = "1";
      }
      if (backData.result[_key2].src_port_group.length > 0) {
        backData.result[_key2].srcPortType = "2";
      } else {
        backData.result[_key2].srcPortType = "1";
      }
      if (backData.result[_key2].protocol === "IP" || backData.result[_key2].protocol === "ICMP") {
        backData.result[_key2].hasPort = "0";
      } else {
        backData.result[_key2].hasPort = "1";
      }
    }
  }
  return backData;
}; /*自定义应用程序页面处理*/
var initBackDataProcessDpi = function initBackDataProcessDpi(backData) {
  if (backData.result.length > 0) {
    for (var _key4 in backData.result) {
      if (backData.result[_key4].protocol === "IP" || backData.result[_key4].protocol === "ICMP") {
        backData.result[_key4].hasPort = "0";
      } else {
        backData.result[_key4].hasPort = "1";
      }
    }
  }
  return backData;
}; /*密码加密*/
var key = "sd-wan@supercxp.";
function _crypto(msg) {
  return CryptoJs.AES.encrypt(msg, key).toString();
}
function MomentFormatter(moment, formatter) {
  return moment.format(formatter || "YYYY-MM-DD HH:mm:ss");
} //解析url query string
function parse(str) {
  return qs.parse(str.slice(1));
} //针对STEP,CSTEP设备类型做字符转换
function deviceTypeMap(type) {
  var deviceTypeMap = {
    STEP: "BCPE",
    CSTEP: "HCPE",
    AP: "AP"
  };
  return deviceTypeMap[type] || type;
}
function deviceTypeMapReverse(type) {
  var deviceTypeMap = {
    BCPE: "STEP",
    HCPE: "CSTEP",
    AP: "AP"
  };
  return deviceTypeMap[type] || type;
}
function LinkType(type) {
  var deviceTypeMap = {
    CLOUD_VPN: "Cloud VPN",
    CLOUD_SPLINE: "Cloud dedicated line",
    SUPER_CLOUD_SPLINE: "Super cloud dedicated line"
  };
  return deviceTypeMap[type] || type;
}
function statusMap(status) {
  switch (status) {
    case "INIT":
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        style: {
          width: 8,
          height: 8,
          marginRight: 5,
          background: '#F1B442',
          borderRadius: 8,
          display: 'inline-block',
          verticalAlign: 'middle'
        }
      }), "not active");
    case "ONLINE":
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        style: {
          width: 8,
          height: 8,
          marginRight: 5,
          background: '#50B489',
          borderRadius: 8,
          display: 'inline-block',
          verticalAlign: 'middle'
        }
      }), "on-line");
    case "OFFLINE":
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        style: {
          width: 8,
          height: 8,
          marginRight: 5,
          background: '#EE5250',
          borderRadius: 8,
          display: 'inline-block',
          verticalAlign: 'middle'
        }
      }), "off-line");
    default:
      return status;
  }
}
function statusListMap(status) {
  var List = {
    'INIT': {
      color: '#F1B442',
      name: "not active"
    },
    'ONLINE': {
      color: '#50B489',
      name: "on-line"
    },
    'OFFLINE': {
      color: '#EE5250',
      name: "off-line"
    }
  };
  return List[status] || {
    name: status,
    color: '#FFD02D'
  };
}
function haTypeMap(status) {
  var List = {
    'ha': "Equipment master and backup",
    'cluster': "Device cluster",
    'double_center': "Link master and backup",
    'backup_mutual': "Link backup"
  };
  return List[status] || status;
}
var haTypeList = [{
  name: "Equipment master and backup",
  value: 'ha',
  key: 'ha'
}, {
  name: "Device cluster",
  value: 'cluster',
  key: 'cluster'
}, {
  name: "Link master and backup",
  value: 'double_center',
  key: 'double_center'
}, {
  name: "Link backup",
  value: 'backup_mutual',
  key: 'backup_mutual'
}];
function roleMap(role) {
  var roleMap = {
    company: "Enterprise administrator",
    companystaff: "Ordinary users",
    supercxpbusiness: "business affairs",
    supercxptechnology: "Operation and maintenance",
    supercxptechsupport: "technical support",
    supercxpbizadmin: "Business Supervisor",
    supercxptechadmin: "Technical Support Supervisor",
    supercxpadmin: "administrators"
  };
  return roleMap[role] || role;
}
function localeMap(role) {
  var roleMap = {
    "zh-TW": "繁體中文",
    "zh-CN": "简体中文",
    "en-US": "English"
  };
  return roleMap[role] || role;
}
function commonTranslate(component) {
  return function (message, originNm) {
    try {
      return component.props.intl.formatMessage(message);
    } catch (err) {
      return originNm;
    }
  };
}
function emptyFunction() {}
function mainBackupMap(type) {
  var mainBackupMap = {
    None: "nothing",
    edge_main: "Edge Master",
    edge_backup: "Edge backup",
    center_main: "Center Master",
    center_backup: "Central backup",
    "center_main,edge_main": "Center Master, Edge Master",
    "center_main,edge_backup": "Central main, edge backup",
    "center_backup,edge_main": "Center backup, edge master",
    "center_backup,edge_backup": "Center backup, edge backup"
  };
  return mainBackupMap[type] || type;
}
var viewChinese = {
  "删除FullMesh链路": "Delete FullMesh Link",
  "修改节点": "Modify nodes",
  "创建节点": "Create nodes",
  "删除CPE型号": "Delete CPE model",
  "删除4G信息": "Delete 4G information",
  "修改账号": "Modify account",
  "创建运营商": "Create an operator",
  "创建链路": "Create Link",
  "创建大区": "Create Region",
  "删除节点组": "Delete Node Group",
  "删除运营商": "Delete operator",
  "修改链路": "Modify Link",
  "删除合同": "Delete Contract",
  "删除docker isp": "Delete Docker ISP",
  "修改docker isp": "Modify Docker ISP",
  "修改docker物理主机": "Modify Docker Physical Host",
  "删除大区": "Delete Region",
  "创建FullMesh链路": "Create a FullMesh link",
  "删除企业黑名单": "Delete enterprise blacklist",
  "新增部门": "New department",
  "迁移设备": "Migrating devices",
  "批量启用/禁用安全配置": "Batch Enable/Disable Security Configuration",
  "修改ssid模板": "Modify ssid template",
  "修改区域": "Modify Region",
  "启用/禁用账号": "Enable/disable account",
  "修改4G信息": "Modify 4G information",
  "删除docker物理主机": "Delete Docker Physical Host",
  "创建端口组": "Create Port Group",
  "删除ssid模板": "Delete ssid template",
  "删除QoS配置": "Delete QoS configuration",
  "创建安全配置": "Create Security Configuration",
  "创建CPE型号": "Create CPE model",
  "新增库存": "Add inventory",
  "删除账期": "Delete accounting period",
  "修改库存": "Modify inventory",
  "修改BGP": "Modify BGP",
  "删除安全配置": "Delete Security Configuration",
  "创建企业": "Creating a business",
  "删除白名单": "Delete whitelist",
  "创建合同": "Create Contract",
  "个性化配置wifi": "Personalized WiFi configuration",
  "删除部门": "Delete Department",
  "登录": "Sign in",
  "添加ssid模板分配": "Add ssid template assignment",
  "创建账号": "Create an account",
  "删除自定义应用": "Delete Custom App",
  "创建平台自定义应用": "Create platform custom applications",
  "删除机房isp": "Delete machine room ISP",
  "修改IP段": "Modify IP segment",
  "删除黑名单": "Remove blacklist",
  "修改IP组": "Modify IP Group",
  "修改密码": "Change Password",
  "批量启用/禁用QoS配置": "Batch Enable/Disable QoS Configuration",
  "新增docker物理主机": "Add Docker Physical Host",
  "注销": "cancellation",
  "修改设备": "Modify device",
  "创建IP组": "Create IP Group",
  "创建4G信息": "Create 4G information",
  "创建机房": "Create a computer room",
  "创建节点组": "Create Node Group",
  "更新FullMesh链路": "Update FullMesh Link",
  "删除ssid模板分配": "Delete ssid template assignment",
  "新增设备": "New Equipment",
  "删除端口组": "Delete Port Group",
  "删除库存": "Delete inventory",
  "出库": "Outbound",
  "删除区域": "Delete Region",
  "删除链路": "Delete Link",
  "删除企业联系人": "Delete Enterprise Contact",
  "创建黑名单": "Create blacklist",
  "修改CPE型号": "Modify CPE model",
  "修改root密码": "Change the root password",
  "批量修改链路": "Batch Modify Links",
  "新增docker isp": "Add Docker ISP",
  "创建ssid模板": "Create ssid template",
  "修改BGP地址段": "Modify BGP address segment",
  "删除机房": "Delete machine room",
  "修改机房isp": "Modifying the computer room ISP",
  "修改机房": "Modify the computer room",
  "更新QoS配置": "Update QoS configuration",
  "修改节点组": "Modify Node Group",
  "删除节点": "Delete Node",
  "更新大区": "Update Region",
  "批量预订库存": "Bulk booking inventory",
  "更新ssid模板分配": "Update ssid template allocation",
  "修改合同": "Modify the contract",
  "删除/回收设备": "Delete/Recycle Equipment",
  "更新去重规则": "Update deduplication rules",
  "修改lte应用级别": "Modify lte application level",
  "删除IP组": "Delete IP Group",
  "修改端口组": "Modify Port Group",
  "新增区域": "New Area",
  "创建企业联系人": "Create Enterprise Contact",
  "设备交换": "Device exchange",
  "删除IP段": "Delete IP segment",
  "创建IP段": "Create IP segment",
  "删除账号": "Delete account",
  "创建账期": "Create accounting period",
  "修改部门": "Modify Department",
  "修改自定义应用": "Modify custom applications",
  "启用/禁用智能压缩": "Enable/disable intelligent compression",
  "修改企业信息": "Modifying Enterprise Information",
  "修改安全配置": "Modifying Security Configuration",
  "新增机房isp": "Add a new computer room ISP",
  "修改账期": "Modify accounting period",
  "创建QoS配置": "Create QoS configuration",
  "修改企业联系人": "Modify Enterprise Contact Person",
  "创建企业黑名单": "Create a corporate blacklist",
  "修改运营商": "Modify operator",
  "重置密码": "reset password ",
  "删除企业": "Delete Enterprise",
  "创建白名单": "Create a whitelist"
};
function viewChineseMap(value) {
  return viewChinese[value] || "";
}
function deviceIPType(type) {
  var deviceTypeMap = {
    inner: "Intranet IP",
    out_ip: "Automatic acquisition",
    fixed: "Fixed IP"
  };
  return deviceTypeMap[type] || type;
}
function actionMap(type) {
  var deviceTypeMap = {
    IN: "Warehousing",
    OUT: "Outbound",
    move_device: "Device Migration",
    exchange_device: "Device exchange",
    delete_device: "Equipment recycling"
  };
  return deviceTypeMap[type] || type;
}
function dateMap(type) {
  var deviceTypeMap = {
    day: "day",
    year: "year",
    month: "month",
    season: "quarter"
  };
  return deviceTypeMap[type] || type;
}
function healthMap(type) {
  var deviceTypeMap = {
    danger: {
      name: "high-risk",
      color: '#EE5250'
    },
    warning: {
      name: "sub-health",
      color: '#F1B442'
    },
    healthy: {
      name: "normal",
      color: '#50B489'
    }
  };
  return deviceTypeMap[type] || type;
}
var healthList = [{
  name: "high-risk",
  value: 'danger',
  key: 'danger'
}, {
  name: "sub-health",
  value: 'warning',
  key: 'warning'
}, {
  name: "normal",
  value: 'healthy',
  key: 'healthy'
}];
function healthMapRender(status) {
  switch (status) {
    case "danger":
      return /*#__PURE__*/React.createElement("span", {
        style: {
          color: healthMap('danger').color,
          border: '1px solid',
          borderColor: healthMap('danger').color,
          borderRadius: 10,
          padding: '0 10px',
          marginLeft: 10,
          cursor: 'pointer'
        }
      }, healthMap('danger').name);
    case "warning":
      return /*#__PURE__*/React.createElement("span", {
        style: {
          color: healthMap('warning').color,
          border: '1px solid',
          borderColor: healthMap('warning').color,
          borderRadius: 10,
          padding: '0 10px',
          marginLeft: 10,
          cursor: 'pointer'
        }
      }, healthMap('warning').name);
    case "healthy":
      return /*#__PURE__*/React.createElement("span", {
        style: {
          color: healthMap('healthy').color,
          border: '1px solid',
          borderColor: healthMap('healthy').color,
          borderRadius: 10,
          padding: '0 10px',
          marginLeft: 10
        }
      }, healthMap('healthy').name);
    default:
      return status;
  }
}
var warnLevelList = [{
  name: "urgent",
  value: 3,
  label: "urgent",
  color: '#EE5250'
}, {
  name: "important",
  value: 2,
  label: "important",
  color: '#F28D47'
}, {
  name: "secondary",
  value: 1,
  label: "secondary",
  color: '#F7B744'
}, {
  name: "Tips",
  value: 0,
  label: "Tips",
  color: '#49ADDA'
}];
function warnLevelMap(type) {
  var warnLevelMap = {
    '3': {
      name: "urgent",
      color: '#EE5250'
    },
    '2': {
      name: "important",
      color: '#F28D47'
    },
    '1': {
      name: "secondary",
      color: '#F7B744'
    },
    '0': {
      name: "Tips",
      color: '#49ADDA'
    }
  };
  return warnLevelMap[type] || type;
}
var validateIpSegment = function validateIpSegment(rule, value, callback) {
  var arr = value ? value.split(",") : [],
    regExp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
  var flag4 = value === 'any';
  if (value && value.indexOf('-') !== -1) {
    return callback("Input in the format of 1.1.1.0/24,1.1.1.1");
  }
  for (var i = 0, len1 = arr.length; i < len1; i++) {
    var flag1 = false,
      flag2 = false,
      flag3 = false;
    var ipStr = arr[i],
      ipStr1 = ipStr.indexOf("/") !== -1,
      ipStr2 = ipStr.indexOf("-") !== -1;
    if (regExp.test(ipStr) && ipStr1 || regExp.test(ipStr) && ipStr2) {
      flag1 = !flag1;
    }
    if (ipStr1) {
      var ipSeg = ipStr.split("/"),
        regNum = /^[0-9]$|^[1,2]\d$|^3[0-2]$/;
      if (regExp.test(ipSeg[0]) && regNum.test(ipSeg[1])) {
        flag2 = !flag2;
      }
    }
    if (!flag1 && !flag2 && !flag3 && !flag4) {
      return callback("Input in 1.1.1.0/24 format");
    }
  }
  return callback();
};
function deviceImg(model) {
  var defaultImg = nodevice;
  if (model.indexOf('SR10') > -1) {
    if (model === 'SR105-W1L1-P5') {
      defaultImg = SR105W1L1P5;
    } else if (model === 'SR105-W1L1-P10S') {
      defaultImg = SR105W1L1P10S;
    } else if (model === 'SR100-W2L0') {
      defaultImg = SR100W2L0;
    } else if (model === 'SR101-W2L1-P10M3') {
      defaultImg = SR101W2L1P10M3;
    } else if (model === 'SR105-P5') {
      defaultImg = SR105P5;
    } else if (model === 'SR105-W1-P5') {
      defaultImg = SR105W1P5;
    } else if (model === 'SR100-W2L1') {
      defaultImg = SR100W2L1;
    } else if (model === 'SR105-P5F') {
      defaultImg = SR105P5F;
    } else {
      defaultImg = SR100;
    }
  } else if (model.indexOf('SR30') > -1) {
    if (model === 'SR302-P6C') {
      defaultImg = SR302P6C;
    } else if (model === 'SR302-W1-P6C') {
      defaultImg = SR302W1P6C;
    } else if (model === 'SR302-W1L1-P6C') {
      defaultImg = SR302W1L1P6C;
    } else if (model === 'SR303-W1L1-P6C') {
      defaultImg = SR303W1L1P6C;
    } else {
      defaultImg = SR300;
    }
  } else if (model.indexOf('SR50') > -1) {
    defaultImg = SR502P8SD;
  } else if (model === 'SR920') {
    defaultImg = SR920;
  } else if (model === 'VM') {
    defaultImg = VM;
  } else if (model === 'Docker' || model === 'vCPE') {
    defaultImg = DOCKER;
  } else {
    defaultImg = nodevice;
  }
  return defaultImg;
}
function getLen(str) {
  var l = 0;
  var a = str.split("");
  for (var i = 0; i < a.length; i++) {
    if (a[i].charCodeAt(0) < 299) {
      l++;
    } else {
      l += 2;
    }
  }
  return l;
}
function len2(s, len) {
  var l = 0;
  var p = 0;
  var a = s.split("");
  for (var i = 0; l < len; i++) {
    if (a[i].charCodeAt(0) < 299) {
      l++;
      p++;
    } else {
      l += 2;
      p++;
    }
  }
  return p;
}
var linkTypeList = [{
  key: "CLOUD_VPN",
  value: "CLOUD_VPN",
  name: "Cloud VPN",
  text: "Cloud VPN"
}, {
  key: "CLOUD_SPLINE",
  value: "CLOUD_SPLINE",
  name: "Cloud dedicated line",
  text: "Cloud dedicated line"
}, {
  key: "SUPER_CLOUD_SPLINE",
  value: "SUPER_CLOUD_SPLINE",
  name: "Super cloud dedicated line",
  text: "Super cloud dedicated line"
}];
function all_company_update(dispatch, payload) {
  dispatch({
    type: 'indexPage/all_company_update',
    payload: payload
  });
}
function all_relevance_company(data) {
  data.dispatch({
    type: data.submitType,
    payload: data.payload
  });
}
var lineTypeList = [{
  key: "internet",
  value: "internet",
  name: "internet"
}, {
  key: "inter_private",
  value: "inter_private",
  name: "a dedicated line"
}];
function lineTypeMap(type) {
  var lineTypeMap = {
    internet: "internet",
    inter_private: "a dedicated line"
  };
  return lineTypeMap[type] || type;
}
var roomTypeList = [{
  key: "单线机房",
  value: "1",
  name: "Single line machine room"
}, {
  key: "多线机房",
  value: "2",
  name: "Multi line machine room"
}, {
  key: "BGP机房",
  value: "3",
  name: "BGP machine room"
}, {
  key: "海外机房",
  value: "4",
  name: "Overseas computer room"
}];
var appTypeList = [{
  key: "wechat",
  value: 0,
  name: "WeCom"
}, {
  key: "mail",
  value: 1,
  name: "Enterprise email"
}, {
  key: "dingding",
  value: 2,
  name: "Nail group"
}, {
  key: "phone",
  value: 3,
  name: "Voice call"
} // { key: "zong", value: 4, name: "@综合通道" },
];
function appTypeMap(type) {
  var appTypeMap = {
    0: "WeCom",
    1: "Enterprise email",
    2: "Nail group",
    3: "Voice call",
    4: "Comprehensive channel"
  };
  return appTypeMap[type] || type;
}
var ipTypeList = [{
  key: "0",
  value: 0,
  name: "Fixed IP"
}, {
  key: "1",
  value: 1,
  name: "Automatically obtain IP"
}, {
  key: "2",
  value: 2,
  name: "No public IP"
}];
function ipTypeMap(type) {
  var ipTypeMap = {
    0: "Fixed IP",
    1: "Automatically obtain IP",
    2: "No public IP"
  };
  return ipTypeMap[type] || type;
}
var detectToolList = [{
  key: "ping",
  value: "ping",
  name: "ping"
}, {
  key: "tracert",
  value: "tracert",
  name: "tracert"
}, {
  key: "tcping",
  value: "tcp",
  name: "tcping"
}];
function taskStatusMap(type) {
  var taskStatusMap = {
    'init': 'UNEXECUTED',
    'doing': 'DOING',
    'success': 'FINISHED',
    'fail': 'FAILED'
  };
  return taskStatusMap[type] || type;
}
var taskStatusList = [{
  key: "init",
  value: "init",
  name: "UNEXECUTED"
}, {
  key: "doing",
  value: "doing",
  name: "DOING"
}, {
  key: "success",
  value: "success",
  name: "FINISHED"
}, {
  key: "fail",
  value: "fail",
  name: "FAILED"
}];
function taskTypeMap(type) {
  var taskTypeMap = {
    'upgrade': 'update',
    'uci_command': 'command',
    'cpe_reset': 'reset'
  };
  return taskTypeMap[type] || type;
}
var taskTypeList = [{
  key: "upgrade",
  value: "upgrade",
  name: "update"
}, {
  key: "uci_command",
  value: "uci_command",
  name: "command"
}, {
  key: "cpe_reset",
  value: "cpe_reset",
  name: "reset"
}];
function weekMap(type) {
  var weekMap = {
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
    7: "Sunday"
  };
  return weekMap[type] || type;
}
var deviceTypeList = [{
  key: "STEP",
  value: "STEP",
  name: "BCPE",
  text: "BCPE"
}, {
  key: "CSTEP",
  value: "CSTEP",
  name: "HCPE",
  text: "HCPE"
}];
var validateIpAndDomain = function validateIpAndDomain(rule, value, callback) {
  var arr = value ? value.split(",") : [],
    regExp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
  var flag4 = value === 'any';
  if (value && value.indexOf('-') !== -1) {
    return callback("Input in the format of 1.1.1.0/24,1.1.1.1");
  }
  for (var i = 0, len1 = arr.length; i < len1; i++) {
    var flag1 = false,
      flag2 = false,
      flag3 = false,
      domainFlag = false;
    var domainReg = /^([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/;
    if (domainReg.test(arr[i])) {
      domainFlag = true;
    }
    var ipStr = arr[i],
      ipStr1 = ipStr.indexOf("/") !== -1; // , ipStr2 = (ipStr.indexOf("-") !== -1);
    if (regExp.test(ipStr)) {
      flag1 = !flag1;
    }
    if (ipStr1) {
      var ipSeg = ipStr.split("/"),
        regNum = /^[0-9]$|^[1,2]\d$|^3[0-2]$/;
      if (regExp.test(ipSeg[0]) && regNum.test(ipSeg[1])) {
        flag2 = !flag2;
      }
    }
    if (!flag1 && !flag2 && !flag3 && !flag4 && !domainFlag) {
      return callback("Input in the format of 1.1.1.0/24,1.1.1.1");
    }
  }
  return callback();
};
var getColumnSearchProps = function getColumnSearchProps(dataIndex, handleSearch, handleReset, _this) {
  return {
    filterDropdown: function filterDropdown(_ref) {
      var setSelectedKeys = _ref.setSelectedKeys,
        selectedKeys = _ref.selectedKeys,
        confirm = _ref.confirm,
        clearFilters = _ref.clearFilters;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 8
        }
      }, /*#__PURE__*/React.createElement(_Input, {
        ref: function ref(node) {
          _this.searchInput = node;
        },
        placeholder: "Please enter",
        value: selectedKeys[0],
        onChange: function onChange(e) {
          return setSelectedKeys(e.target.value ? [e.target.value] : []);
        },
        onPressEnter: function onPressEnter() {
          return handleSearch(selectedKeys, confirm, dataIndex);
        },
        style: {
          width: 188,
          marginBottom: 8,
          display: 'block'
        }
      }), /*#__PURE__*/React.createElement(_Button, {
        type: "primary",
        onClick: function onClick() {
          return handleSearch(selectedKeys, confirm, dataIndex);
        },
        icon: "search",
        size: "small",
        style: {
          width: 90,
          marginRight: 8
        }
      }, "search"), /*#__PURE__*/React.createElement(_Button, {
        onClick: function onClick() {
          return handleReset(clearFilters);
        },
        size: "small",
        style: {
          width: 90
        }
      }, "Reset"));
    },
    filterIcon: function filterIcon(filtered) {
      return /*#__PURE__*/React.createElement(_Icon, {
        type: "search",
        style: {
          color: filtered ? '#1890ff' : undefined
        }
      });
    },
    onFilter: function onFilter(value, record) {
      return record[dataIndex] && record[dataIndex].includes(value.trim());
    },
    onFilterDropdownVisibleChange: function onFilterDropdownVisibleChange(visible) {
      if (visible) {
        setTimeout(function () {
          return _this.searchInput.select();
        });
      }
    }
  };
};
function swStatusMap(type) {
  var swStatusMap = {
    1: "test",
    2: "formal",
    3: "Deactivate"
  };
  return swStatusMap[type] || type;
}
var swStatusList = [{
  key: 1,
  value: 1,
  name: "test"
}, {
  key: 2,
  value: 2,
  name: "formal"
}, {
  key: 3,
  value: 3,
  name: "Deactivate"
}];
var protocolList = [{
  value: 'TCP',
  name: 'TCP',
  text: 'TCP',
  key: 'TCP'
}, {
  value: 'UDP',
  name: 'UDP',
  text: 'UDP',
  key: 'UDP'
},
// { value: 'TCP_UDP', name: 'TCP_UDP', text: 'TCP_UDP', key: 'TCP_UDP' },
{
  value: 'ICMP',
  name: 'ICMP',
  text: 'ICMP',
  key: 'ICMP'
}, {
  value: 'ALL',
  name: 'ALL',
  text: 'ALL',
  key: 'ALL'
}];
var policyTypeMap = {
  'qos_config': {
    name: 'QoS2.0',
    path: 'ci0602',
    keyword: 'name'
  },
  'qos_with_app': {
    name: '隧道Qos',
    path: 'ci0601',
    keyword: 'name'
  },
  'acl_with_app': {
    name: 'ACl配置',
    path: 'ci0501',
    keyword: 'name'
  },
  'acl_config': {
    name: 'ACl2.0',
    path: '',
    keyword: 'name'
  },
  //
  'qos_internet': {
    name: '互联网Qos',
    path: 'ci3901',
    keyword: 'name'
  },
  'app_limit': {
    name: 'IP限速',
    path: 'ci3906',
    keyword: 'name'
  },
  'single_ip_limit': {
    name: '单IP限速',
    path: 'ci4001',
    keyword: 'name'
  },
  'load_balance': {
    name: '多线路负载',
    path: 'ci4105',
    keyword: 'priority_no'
  },
  'mutil_dns': {
    name: '多线路DNS代理',
    path: 'ci4106',
    keyword: 'default_wans'
  },
  'batch_dns': {
    name: '域名解析',
    path: 'ci4104',
    keyword: 'global_dns'
  },
  'batch_wifi': {
    name: 'WIFI配置',
    path: 'ci4103',
    keyword: 'old_ssid'
  },
  'flow_control': {
    name: '目标引流',
    path: 'ci3903',
    keyword: 'name'
  },
  //
  'flow_control_Source': {
    name: '源地址引流 ',
    path: 'ci3904',
    keyword: 'name'
  },
  //
  'resource_group': {
    name: '资源分组',
    path: 'mi2202',
    keyword: 'name'
  },
  'bw_limit': {
    name: 'IP限速2.0',
    path: 'ci3907',
    keyword: 'name'
  },
  'vyos_static_route': {
    name: '静态路由',
    path: '',
    keyword: 'name'
  },
  //
  'ip_group_device_relation': {
    name: '已在设备中创建',
    path: '',
    keyword: 'name'
  },
  //
  'nginx_proxy': {
    name: '代理优化',
    path: 'ci3908',
    keyword: 'name'
  } //
};
function evalFunctionsMap(type) {
  var evalFunctionsMap = {
    'gt': "greater than",
    'lt': "less than",
    'outside_range': "Outside the scope",
    'within_range': "Within the scope"
  };
  return evalFunctionsMap[type] || type;
}
function alertUnitMap(unit) {
  var alertUnitMap = {
    ms: 1,
    s: 1000,
    m: 60 * 1000,
    h: 60 * 60 * 1000,
    d: 24 * 60 * 60 * 1000,
    w: 7 * 24 * 60 * 60 * 1000,
    y: 365 * 24 * 60 * 60 * 1000
  };
  return alertUnitMap[unit];
}
function expressionMap(type) {
  var expressionMap = {
    0: 'EVALUATOR',
    1: 'MATH',
    2: 'REDUCE'
  };
  return expressionMap[type];
}
function alertNameMap(type) {
  var alertNameMap = {
    'WAN口探测失败': 'WAN Detection Failed',
    'WAN口丢包率高': 'High WAN Packet Loss',
    '内存使用率高': 'High Memory Usage',
    'WAN口延迟较高': 'High WAN Latency',
    '程序crash': 'Program Crash',
    '隧道断开': 'Tunnel Disconnected',
    '带宽使用较高': 'High Bandwidth Usage',
    '隧道GET值异常': 'Tunnel GET Abnormal',
    'CPU使用率高': 'High CPU Usage',
    '设备离线': 'Device Offline',
    '磁盘使用率高': 'High Disk Usage'
  };
  return alertNameMap[type] || type;
}
export { viewChineseMap, mainBackupMap, emptyFunction, localeMap, roleMap, deviceTypeMapReverse, deviceTypeMap, _crypto, validateIp, validatePort, addComma, initBackDataProcess, initBackDataProcessDpi, MomentFormatter, parse, commonTranslate, statusMap, deviceIPType, statusListMap, LinkType, actionMap, dateMap, healthList, healthMap, healthMapRender, warnLevelList, validateIpSegment, deviceImg, getLen, len2, linkTypeList, haTypeMap, all_company_update, all_relevance_company, validateOnlyIp, lineTypeList, lineTypeMap, roomTypeList, validateOnlyIpd, appTypeMap, appTypeList, warnLevelMap, ipTypeMap, ipTypeList, detectToolList, haTypeList, taskStatusMap, taskStatusList, taskTypeMap, taskTypeList, weekMap, validateIpAll, deviceTypeList, validateIpAndDomain, getColumnSearchProps, swStatusMap, swStatusList, protocolList, policyTypeMap, evalFunctionsMap, alertUnitMap, expressionMap, alertNameMap };